<template>
  <v-card>
    <v-container style="max-width: 1500px">
      <v-row>
        <v-col cols="12">
          <v-toolbar color="secondary" flat dense>
            <v-toolbar-title>Menu Shortcuts</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="accent" @click="resetLoader" text>
              Reset Loader
            </v-btn>
          </v-toolbar>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-row dense>
            <v-col cols="12" md="3">
              <span style="margin-left: 16px">SETUP</span><br>

              <v-btn to="/company-details" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Company
                Details</v-btn><br />

              <v-btn to="/general-settings" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> General
                Settings</v-btn><br />

              <v-btn to="/printer-setup" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Receipt Layout
                Setup</v-btn><br />

              <v-btn v-show="ExportsVersion != 'Y'" to="/sms-settings" text color="menuColor" left><v-icon
                  left>mdi-view-list</v-icon> Sms
                Settings</v-btn><br />

              <v-btn v-show="ExportsVersion != 'Y'" to="/products/import" text color="menuColor" left><v-icon
                  left>mdi-import</v-icon> Import
                Products</v-btn> <br />

              <v-btn v-show="ExportsVersion != 'Y'" to="/import/product/codes" text color="menuColor" left><v-icon
                  left>mdi-import</v-icon> Product
                Codes</v-btn>

            </v-col>

            <v-col cols="12" md="3">
              <span style="margin-left: 16px">PRODUCTS</span><br>

              <v-btn to="/inventory/uom" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Units Of
                Measure</v-btn><br />

              <v-btn to="/products" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Products
                List</v-btn><br />

              <v-btn to="/product/categories" text color="menuColor" left><v-icon left>mdi-view-list</v-icon>Product
                Categories</v-btn><br />

                <v-btn to="/brands" text color="menuColor" left><v-icon left>mdi-view-list</v-icon>Brands</v-btn><br />

              <v-btn v-show="ExportsVersion != 'Y'" to="/sub-categories" text color="menuColor" left><v-icon
                  left>mdi-view-list</v-icon> Sub
                Categories</v-btn><br />

              <v-btn v-show="ExportsVersion != 'Y'" to="/price-lists" text color="menuColor" left><v-icon
                  left>mdi-view-list</v-icon> Price
                Lists</v-btn><br />

              <v-btn v-show="ExportsVersion != 'Y'" to="/makes" text color="menuColor" left><v-icon
                  left>mdi-view-list</v-icon>Makes</v-btn><br />

              <v-btn v-show="ExportsVersion != 'Y'" to="/product-models" text color="menuColor" left><v-icon
                  left>mdi-view-list</v-icon>Models</v-btn><br />

              <v-btn v-show="ExportsVersion != 'Y'" to="/colors" text color="menuColor" left><v-icon
                  left>mdi-view-list</v-icon>Colors</v-btn><br />

              <v-btn v-show="ExportsVersion != 'Y'" to="/product-types" text color="menuColor" left><v-icon
                  left>mdi-view-list</v-icon>Types</v-btn><br />
            </v-col>

            <v-col cols="12" md="3">
              <span style="margin-left: 16px">SALES</span><br>


              <v-btn to="/customers" text color="menuColor" left><v-icon left>mdi-view-list</v-icon>
                Customers</v-btn><br />

              <v-btn to="/suppliers" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Suppliers</v-btn>
              <br />

              <v-btn v-show="ExportsVersion != 'Y'" to="/payment-terms" text color="menuColor" left><v-icon
                  left>mdi-view-list</v-icon> Payment
                Terms</v-btn><br />


              <v-btn to="/sale-types" text color="menuColor" left><v-icon
                  left>mdi-view-list</v-icon> Sale
                Types</v-btn><br />

              <v-btn to="/store-sections" text color="menuColor" left><v-icon
                  left>mdi-view-list</v-icon> Store
                Sections</v-btn><br />

              <v-btn v-show="ExportsVersion != 'Y'" to="/regions" text color="menuColor" left><v-icon
                  left>mdi-view-list</v-icon> Regions</v-btn><br />


            </v-col>

            <v-col cols="12" md="3">
              <span style="margin-left: 16px">SYSTEM INITIALIZATION</span><br>

              <v-btn to="/document-numbering" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Document
                Numbering</v-btn><br />

                <v-btn to="/gl-accounts-setup" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Gl
                Integration</v-btn><br />

              <!-- <v-btn to="/menu-authorization" text color="menuColor" left
                  ><v-icon left>mdi-view-list</v-icon> Menu Authorization</v-btn
                ><br /> -->

              <v-btn v-if="IsDistributor == 'Y'" to="/stores" text color="menuColor" left><v-icon
                  left>mdi-view-list</v-icon> Stores /
                Branches</v-btn><br />

              <!-- 
                <v-btn to="/tax-groups" text color="menuColor" left
                  ><v-icon left>mdi-view-list</v-icon> Tax Groups</v-btn
                ><br /> -->

              <!-- <v-btn to="/accounts" text color="menuColor" left
                  ><v-icon left>mdi-view-list</v-icon> Accounts List</v-btn
                ><br /> -->

              
            </v-col>

            <!-- <v-col cols="12" md="3">
                <v-btn to="/outsourced-sales" text color="primary" left
                  ><v-icon left>mdi-view-list</v-icon> Outsourced Sales</v-btn
                ></v-col
              > -->
          </v-row>
        </v-col>

      </v-row>

      <snackbar ref="snackbar"></snackbar>
    </v-container>
  </v-card>
</template>


<script>
export default {
  components: {},
  computed: {
    ExportsVersion() {
      return localStorage.getItem("ExportsVersion");
    },
    IsDistributor() {
      return localStorage.getItem("IsDistributor");
    },
    role() {
      return localStorage.getItem("userRole");
    },
  },
  data() {
    return {
      datacollection: {},
      loader: false,
      smsRef: null,
      loading: false,
      record: {},
      callsData: [],
      search: null,
      dashData: {},
      startField: "StartDate",
      endField: "EndDate",
      trueValue: true,
    };
  },
  methods: {
    deleteData() {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/reset-account`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show("Reset Done", "blue");
          } else {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(data) {
      this.record = { ...this.record, [data.fieldName]: data.date };
    },
    resetLoader() {
      this.$store.commit("loader", false);
      this.$store.commit("btnLoader", false);
      this.$refs.snackbar.show("Done", "green");
    },
  },
  created() {

  },
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}

.cardText {
  font-weight: bold;
  font-size: 18px;
  padding: 12px;
  color: #757575;
}

.dash-btn {
  margin-top: -5px;
}
</style>